import { Breadcrumbs } from "../components/Breadcrumbs";
import { useSeo } from "../lib/seo";

export default function Contact() {
  useSeo({
    title: "Contact ProfitMigo",
    description: "Get in touch with ProfitMigo about our profit and pricing calculators, corrections to fee assumptions, or partnership enquiries.",
    path: "/contact",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Contact" }]} />
      <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Contact</h1>
      <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground/80">
        <p>Questions, corrections or feedback about our calculators are always welcome — especially if a fee assumption looks out of date.</p>
        <div className="rounded-lg border border-border bg-card p-6">
          <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Email</div>
          <a href="mailto:hello@profitmigo.com" className="mt-1 block font-medium text-primary" data-testid="contact-email">hello@profitmigo.com</a>
        </div>
        <p className="text-sm text-muted-foreground">We aim to respond within a few business days.</p>
      </div>
    </div>
  );
}
